// import AppHelper from '../helpers/AppHelper';
import YoubrioApiHelper from '../helpers/YoubrioApiHelper';

export const getPracticeRoomProfile = ({ userId }) => {
  return YoubrioApiHelper.get(`practice-room-profile?userId=${userId}`, true);
};

